import { useInView } from 'react-intersection-observer'
import { useEffect, Suspense } from 'react'

const withLoadWhenVisible = (
  Component,
  skeletonComponent = (props: any) => '<div />',
  lazy = true
) => {
  const EnhancerComponent = ({ actionOnMounted, ...props }) => {
    const { ref, inView } = useInView({ triggerOnce: true })

    useEffect(() => {
      if (inView && actionOnMounted) {
        actionOnMounted()
      }
    }, [inView])

    return (
      <div ref={ref} className="WithLoadWhenVisible">
        {inView ? (
          lazy ? (
            <Suspense fallback={skeletonComponent(props)}>
              <Component {...props} />
            </Suspense>
          ) : (
            <Component {...props} />
          )
        ) : (
          skeletonComponent(props)
        )}
      </div>
    )
  }

  return EnhancerComponent
}

export default withLoadWhenVisible
